import { guardarArchivo, base64ToBlob } from "../../../../Utils/Functions/Files";
import { findFile } from "../../../../Fetch/GetPDF";
import LogoPDF from "../../../../PDF.svg";
import LogoDown from "../../../../Download.svg";
import CadView from "./CadView";
export default function ViewFile(props) {

  

    const pdfDL = (e, hash, id) => {
        e.preventDefault();

        findFile(hash, id).then(res => {
            if (res.valid) {
                if (res.payload.length > 0) {
                    const blob = base64ToBlob(res.payload[0].file);
                    guardarArchivo(blob, `${res.payload[0].file_name}.${res.payload[0].ext}`);
                }
            }

        })
    }

    switch (props.data.ext) {

        case 'dxf':
            return (
                <>
                <tr>
                    <td>
                        {props.data.desc}
                    </td>
                    <td>
                        {`${props.data.file_name}.${props.data.ext}`}
                    </td>
                    <td>
                        <img className="img_button" onClick={(e) => pdfDL(e, props.data.IdFilehash, props.data.idCotizacion_File_li)} src={LogoDown} alt={`filesD-${props.data.idCotizacion_File_li}`} />
                    </td>
                </tr>
                <tr className='Orden'>
                    <td colSpan={3}>
                            <CadView hash={props.data.IdFilehash} id={props.data.idCotizacion_File_li} />
                    </td>
                </tr>
                </>
            )
            
        case 'pdf':
            return (
                <tr>
                    <td>
                        {props.data.desc}
                    </td>
                    <td>
                        {`${props.data.file_name}.${props.data.ext}`}
                    </td>
                    <td>
                        <img className="img_button" onClick={(e) => pdfDL(e, props.data.IdFilehash, props.data.idCotizacion_File_li)} src={LogoPDF} alt={`filesD-${props.data.idCotizacion_File_li}`} />
                    </td>
                </tr>
            )

        default:
            return (
                <tr>
                    <td>
                        {props.data.desc}
                    </td>
                    <td>
                        {`${props.data.file_name}.${props.data.ext}`}
                    </td>
                    <td>
                        <img className="img_button" onClick={(e) => pdfDL(e, props.data.IdFilehash, props.data.idCotizacion_File_li)} src={LogoDown} alt={`filesD-${props.data.idCotizacion_File_li}`} />
                    </td>
                </tr>
            )
    }
}
